import { IS_APPLE } from "~/lib/environment"

export const SHORTCUTS = Object.freeze({
	NORMAL: IS_APPLE ? "⌘+Opt+0" : "Ctrl+Alt+0",
	HEADING1: IS_APPLE ? "⌘+Opt+1" : "Ctrl+Alt+1",
	HEADING2: IS_APPLE ? "⌘+Opt+2" : "Ctrl+Alt+2",
	HEADING3: IS_APPLE ? "⌘+Opt+3" : "Ctrl+Alt+3",
	BULLET_LIST: IS_APPLE ? "⌘+Shift+8" : "Ctrl+Shift+8",
	NUMBERED_LIST: IS_APPLE ? "⌘+Shift+7" : "Ctrl+Shift+7",
	CODE_BLOCK: IS_APPLE ? "⌘+Opt+C" : "Ctrl+Alt+C",

	STRIKETHROUGH: IS_APPLE ? "⌘+Shift+S" : "Ctrl+Shift+S",

	BOLD: IS_APPLE ? "⌘+B" : "Ctrl+B",
	ITALIC: IS_APPLE ? "⌘+I" : "Ctrl+I",
	UNDERLINE: IS_APPLE ? "⌘+U" : "Ctrl+U"
})
